import { useState, type FormEvent } from "react";
import { useWorkspace } from "../features/workspace-context";

export function ProfilePage() {
  const { data, updateProfile, mode } = useWorkspace();
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [form, setForm] = useState(() => ({
    displayName: data?.currentProfile.displayName ?? "",
    handle: data?.currentProfile.handle ?? "",
    avatarUrl: data?.currentProfile.avatarUrl ?? null,
  }));
  if (!data) return null;

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setSaving(true);
    setSaved(false);
    try {
      await updateProfile({
        ...form,
        handle: form.handle.toLowerCase().replace(/[^a-z0-9_-]/g, ""),
      });
      setSaved(true);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page-stack page-stack--narrow">
      <section className="section-heading">
        <span className="eyebrow">Identidad de colaboración</span>
        <h1>Perfil</h1>
        <p>
          El handle permite que un owner agregue una cuenta existente a un proyecto sin exponer
          correos.
        </p>
      </section>
      <section className="panel profile-panel">
        <div className="avatar avatar--large">{form.displayName.slice(0, 1).toUpperCase()}</div>
        <form className="form-stack" onSubmit={(event) => void submit(event)}>
          <label>
            Nombre visible
            <input
              required
              value={form.displayName}
              onChange={(event) => setForm({ ...form, displayName: event.target.value })}
            />
          </label>
          <label>
            Handle
            <input
              required
              minLength={3}
              value={form.handle}
              onChange={(event) => setForm({ ...form, handle: event.target.value })}
            />
            <small>Solo minúsculas, números, guion y guion bajo.</small>
          </label>
          <label>
            Avatar URL opcional
            <input
              value={form.avatarUrl ?? ""}
              onChange={(event) => setForm({ ...form, avatarUrl: event.target.value || null })}
            />
          </label>
          {mode === "demo" && (
            <div className="notice notice--info">
              En modo demo, el perfil se conserva únicamente en este navegador.
            </div>
          )}
          {saved && <div className="notice notice--success">Perfil actualizado.</div>}
          <button className="button button--primary" disabled={saving} type="submit">
            {saving ? "Guardando…" : "Guardar perfil"}
          </button>
        </form>
      </section>
    </div>
  );
}
